import React from 'react';
import { parseTwitchVodId } from '../twitchEmbed';
import { TWITCH_VOD_UNAVAILABLE_COPY } from '../archiveCopy';
import TwitchPlayer from './TwitchPlayer';

interface TwitchVodEmbedProps {
  providerVodId?: string | null;
  embedUrl?: string | null;
  embedParentDomains?: string[] | null;
  title?: string;
  thumbnailUrl?: string | null;
  twitchUrl?: string | null;
  showExternalLink?: boolean;
}

export function resolveTwitchVodEmbedVideoId(options: {
  providerVodId?: string | null;
  embedUrl?: string | null;
  twitchUrl?: string | null;
}): string | null {
  return (
    options.providerVodId?.trim() ||
    parseTwitchVodId(options.twitchUrl) ||
    parseTwitchVodId(options.embedUrl) ||
    null
  );
}

const TwitchVodEmbed: React.FC<TwitchVodEmbedProps> = ({
  providerVodId,
  embedUrl,
  embedParentDomains,
  title,
  thumbnailUrl,
  twitchUrl,
  showExternalLink,
}) => {
  const videoId = resolveTwitchVodEmbedVideoId({
    providerVodId,
    embedUrl,
    twitchUrl,
  });

  return (
    <div data-testid={videoId ? 'twitch-vod-embed' : 'twitch-vod-embed-unavailable'}>
      <TwitchPlayer
        mode="vod"
        videoId={videoId}
        title={title}
        autoplay={false}
        fallbackUrl={twitchUrl}
        thumbnailUrl={thumbnailUrl}
        embedParentDomains={embedParentDomains}
        vodUnavailableCopy={TWITCH_VOD_UNAVAILABLE_COPY}
        showExternalLink={showExternalLink}
      />
    </div>
  );
};

export default TwitchVodEmbed;
